 <div fxLayout="column" class="module-dialog-container">
  <div fxLayout="row" fxLayoutAlign="space-between center"
    class="dialog-header">
    <h1 mat-dialog-title>{{ title }}</h1>
  </div>

  <div class="dialog-content">
    <!-- Exibição dos planos do cliente quando disponíveis -->
    <div *ngIf="showPlans" class="customer-plans">
      <table mat-table [dataSource]="customerPlans"
        class="mat-elevation-z1 plans-table">
        <!-- Código Column -->
        <ng-container matColumnDef="code">
          <th mat-header-cell *matHeaderCellDef>CÓD.</th>
          <td mat-cell *matCellDef="let plan">{{ plan.code }}</td>
        </ng-container>

        <!-- Tipo Column -->
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>TIPO</th>
          <td mat-cell *matCellDef="let plan">{{ plan.type }}</td>
        </ng-container>

        <!-- Sistema Column -->
        <ng-container matColumnDef="system">
          <th mat-header-cell *matHeaderCellDef>SISTEMA</th>
          <td mat-cell *matCellDef="let plan">{{ plan.system }}</td>
        </ng-container>

        <!-- Quantidade de Terminais Column -->
        <ng-container matColumnDef="terminalQuantity">
          <th mat-header-cell *matHeaderCellDef>QTD.TERM</th>
          <td mat-cell *matCellDef="let plan">{{ plan.terminalQuantity }}</td>
        </ng-container>

        <!-- Mensalidade Column -->
        <ng-container matColumnDef="monthlyValue">
          <th mat-header-cell *matHeaderCellDef>MENSAL.</th>
          <td mat-cell *matCellDef="let plan">{{ plan.monthlyValue |
            currency:'BRL' }}</td>
        </ng-container>

        <!-- Vencimento Column -->
        <ng-container matColumnDef="dueDate">
          <th mat-header-cell *matHeaderCellDef>VENC.</th>
          <td mat-cell *matCellDef="let plan">{{ plan.dueDate }}</td>
        </ng-container>

        <!-- Taxa de Adesão Column -->
        <ng-container matColumnDef="adhesionFee">
          <th mat-header-cell *matHeaderCellDef>TX.ADESÃO</th>
          <td mat-cell *matCellDef="let plan">{{ plan.adhesionFee |
            currency:'BRL' }}</td>
        </ng-container>

        <!-- Quantidade de Dias Corridos Column -->
        <ng-container matColumnDef="daysCountQuantity">
          <th mat-header-cell *matHeaderCellDef>QT.DIAS</th>
          <td mat-cell *matCellDef="let plan">{{ plan.daysCountQuantity }}</td>
        </ng-container>

        <!-- Valor Dias Corridos Column -->
        <ng-container matColumnDef="daysCountValue">
          <th mat-header-cell *matHeaderCellDef>VR.DIAS</th>
          <td mat-cell *matCellDef="let plan">{{ plan.daysCountValue |
            currency:'BRL' }}</td>
        </ng-container>

        <!-- Valor Implantação Column -->
        <ng-container matColumnDef="deploymentValue">
          <th mat-header-cell *matHeaderCellDef>VR.IMPL.</th>
          <td mat-cell *matCellDef="let plan">{{ plan.deploymentValue |
            currency:'BRL' }}</td>
        </ng-container>

        <ng-container matColumnDef="createdAt">
          <th mat-header-cell *matHeaderCellDef>CRIADO EM</th>
          <td mat-cell *matCellDef="let plan">{{ plan.createdAt |
            date:'dd/MM/yyyy HH:mm' }}</td>
        </ng-container>

        <!-- Ativo Column -->
        <ng-container matColumnDef="active">
          <th mat-header-cell *matHeaderCellDef>STATUS</th>
          <td mat-cell *matCellDef="let plan">
            <mat-icon *ngIf="plan.active"
              class="item-icon-active">check</mat-icon>
            <mat-icon *ngIf="!plan.active"
              class="item-icon-inactive">close</mat-icon>
          </td>
        </ng-container>

        <!-- Botão Módulos Column -->
        <ng-container matColumnDef="modules">
          <th mat-header-cell *matHeaderCellDef>MÓDULOS</th>
          <td mat-cell *matCellDef="let plan">
            <button mat-icon-button (click)="viewPlanModules(plan)"
              matTooltip="Visualizar Módulos"
              [disabled]="!plan.systemModules || plan.systemModules.length === 0">
              <mat-icon class="modules-button">extension</mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Botão Info Column -->
        <ng-container matColumnDef="info">
          <th mat-header-cell *matHeaderCellDef>INFO</th>
          <td mat-cell *matCellDef="let plan">
            <button mat-icon-button (click)="showPlanInfo(plan)"
              matTooltip="Visualizar Informações">
              <mat-icon class="info-button">info</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row
          *matHeaderRowDef="['code', 'type', 'system', 'terminalQuantity', 'monthlyValue', 'dueDate', 'adhesionFee', 'daysCountQuantity', 'daysCountValue', 'deploymentValue', 'createdAt', 'active', 'modules', 'info']"></tr>
        <tr mat-row
          *matRowDef="let row; columns: ['code', 'type', 'system', 'terminalQuantity', 'monthlyValue', 'dueDate', 'adhesionFee', 'daysCountQuantity', 'daysCountValue', 'deploymentValue', 'createdAt', 'active', 'modules', 'info'];"></tr>
      </table>

      <!-- Totais -->
      <div class="plans-totals">
        <span class="title">IMPLANTAÇÃO:</span>
        <span class="title-monthly-value"> {{ getTotalDeploymentValue() |
          currency:'BRL' }}</span> &nbsp; | &nbsp;
        <span class="title">DIAS CORRIDOS:</span>
        <span class="title-monthly-value">{{ getTotalDaysCountValue() |
          currency:'BRL' }}</span> &nbsp; | &nbsp;
        <span class="title">TAXA ADESÃO:</span>
        <span class="title-monthly-value">{{ getTotalAdhesionFee() |
          currency:'BRL' }}</span> &nbsp; | &nbsp;
        <span class="title-monthly-title">MENSALIDADE:</span>
        <span class="title-monthly-value">{{ getTotalMonthlyValue() |
          currency:'BRL' }}</span>
      </div>
    </div>

    <!-- Exibição de módulos (comportamento original) -->
    <div *ngIf="!showPlans && systemModules && systemModules.length > 0"
      class="module-list">
      <div *ngFor="let module of systemModules" class="module-card"
        [matTooltip]="module.name"
        matTooltipClass="module-tooltip">
        <div class="module-icon-container">
          <mat-icon class="module-icon">extension</mat-icon>
        </div>
        <div class="module-details">
          <span class="module-name">{{ module.name }}</span>
        </div>
      </div>
    </div>
    <div
      *ngIf="!showPlans && !dataDialog.element.isInfoOnly && (!systemModules || systemModules.length === 0)"
      class="no-modules">
      <mat-icon>info</mat-icon>
      <span>Nenhum módulo selecionado para este item.</span>
    </div>

    <!-- Observação do plano -->
    <div *ngIf="dataDialog?.element?.observation" class="observation-info">
      <div class="section-header">
        <mat-icon>description</mat-icon>
        <h2 mat-dialog-title>OBSERVAÇÃO</h2>
      </div>
      <div class="info-content">
        <div class="observation-text">{{ dataDialog.element.observation }}</div>
      </div>
    </div>

    <!-- Informações de cancelamento -->
    <div *ngIf="canceledAt" class="cancellation-info">
      <div class="section-header">
        <mat-icon>cancel</mat-icon>
        <h2 mat-dialog-title>INFORMAÇÕES DE CANCELAMENTO</h2>
      </div>
      <div class="info-content">
        <div class="info-row">
          <span class="label">Cancelado em: </span>
          <span class="value">{{ canceledAt | date : "dd/MM/yyyy HH:mm"
            }}</span>
        </div>
        <div class="info-row">
          <span class="label">Motivo do cancelamento: </span>
          <span class="value">{{ cancellationReason }}</span>
        </div>
      </div>
    </div>

    <!-- Histórico de alterações -->
    <div *ngIf="customerPlanAudits && customerPlanAudits.length > 0"
      class="audit-history">
      <div class="section-header">
        <mat-icon>history</mat-icon>
        <h2 mat-dialog-title>HISTÓRICO DE ALTERAÇÕES</h2>
      </div>
      <div class="audit-list">
        <div *ngFor="let audit of customerPlanAudits" class="audit-item">
          <div class="audit-date">
            <mat-icon>event</mat-icon>
            <span>{{audit.createdAt | date: 'dd/MM/yyyy HH:mm' }}</span>
          </div>
          <div class="audit-reason">{{ audit.reason }}</div>
        </div>
      </div>
    </div>
  </div>

  <div fxLayout="row" fxLayoutAlign="end center" class="dialog-actions">
    <button mat-raised-button color="primary" (click)="closeDialog()"
      class="close-btn">FECHAR</button>
  </div>
</div>
